import { Injectable } from '@angular/core';

import { StatsigService } from '@services/statsig.service';

// define an enum if feature gate key is used anywhere else in the app

export enum EP_FEATURE_FLAGS {
  SKIP_COOKIE_CLEAR = 'fe-skip-clearing-cookies-on-logout',
  EP_TIMECARDS_OVERVIEW_ENABLED = 'wfm-timecards-overview-enabled',
  FE_EP_MAX_GROUP_DEPTH = 'fe-ep-max-group-depth',
  ETT_IS_HARDWARE_IMEI_INFO_ENABLED = 'is_hardware_imei_info_enabled',
  ETT_VEHICLE_EI_VEHICLE_LIST_FILTER_ENABLED = 'ei-fv-vehicle-list-filter',
  ETT_EI_TRAVEL_GROUPS_ENABLED = 'ett-ei-travel-groups-enabled',
  WFM_SURVEY_POC_ENABLED = 'wfm-survey-poc-enabled',
  EP_VIEW_REPORTS_PERMISSION_ENABLED = 'ep-view-reports-permission-enabled',
  EP_DRIVER_BULK_IMPORT_NEW_TEMPLATE_V2_ENABLED = 'ep-bulk-import-driver-template-v2',
  ETT_EXTENDED_VIDEO_RECALL_ENABLED = 'ett-extended-video-recall-enabled',
  ETT_EXTENDED_VIDEO_RECALL_LINK_ENABLED = 'ett-extended-video-recall-link-enabled',
  EP_REPORTS_DIRECT_LINK_BUG_FIXED = 'reports-direct-link-bug-v2',
  VEHICLE_GATEWAY_TROUBLESHOOTING_PHASE_1 = 'vehicle-gateway-troubleshooting-phase-1',
  DVE_DRIVER_READER_SETTINGS_COMPATIBLE_SW_VERSION = 'dve-driver-reader-settings-compatible-sw-version',
  EP_ALERTS_VIA_WHATSAPP_ENABLED = 'ep-alerts-via-whatsapp-enabled',
  EP_BROADCAST_MESSAGE_ENHANCEMENT_ENABLED = 'ep-broadcast-message-enhancement-enabled',
  EP_ALERTS_VIA_SMS_ENABLED = 'enterprise-platform-alert-sms-enabled',
  EP_DOCUMENT_TEMPLATE_VISIBILITY_ENABLED = 'ep-document-templates-visibility-enabled',
  REPORTS_ALTERNATE_WIDTH_CALCULATION_ENABLED = 'reports-alternate-width-calculation-enabled',
}

@Injectable({ providedIn: 'root' })
export class EnterprisePlatformFeatureFlagService {
  constructor(private statsigService: StatsigService) { }

  public skipCookieClear(): boolean {
    return this.statsigService
      .evaluateGate(EP_FEATURE_FLAGS.SKIP_COOKIE_CLEAR);
  }

  public getMaxGroupDepth(): number {
    return this.statsigService
      .evaluateDynamicConfig(EP_FEATURE_FLAGS.FE_EP_MAX_GROUP_DEPTH)?.value?.maximumGroupDepth as number || 7;
  }


  public isEITravelGroupChangesEnabled(): boolean {
    return this.statsigService
      .evaluateGate(EP_FEATURE_FLAGS.ETT_EI_TRAVEL_GROUPS_ENABLED);
  }

  public isVehicleListStatusFilterEnabled(): boolean {
    return this.statsigService.evaluateGate(EP_FEATURE_FLAGS.ETT_VEHICLE_EI_VEHICLE_LIST_FILTER_ENABLED);
  }

  public isTimecardsOverviewEnabled(): boolean {
    return this.statsigService
      .evaluateGate(EP_FEATURE_FLAGS.EP_TIMECARDS_OVERVIEW_ENABLED);
  }

  public isSurveyPocEnabled(): boolean {
    return this.statsigService
      .evaluateGate(EP_FEATURE_FLAGS.WFM_SURVEY_POC_ENABLED);
  }

  public isReportsPermissionEnforcementEnabled(): boolean {
    return this.statsigService
      .evaluateGate(EP_FEATURE_FLAGS.EP_VIEW_REPORTS_PERMISSION_ENABLED);
  }

  public isNewDriverBulkImportTemplateEnabled(): boolean {
    return this.statsigService.evaluateGate(EP_FEATURE_FLAGS.EP_DRIVER_BULK_IMPORT_NEW_TEMPLATE_V2_ENABLED);
  }

  public isExtendedVideoRecallEnabled(): boolean {
    return this.statsigService.evaluateGate(EP_FEATURE_FLAGS.ETT_EXTENDED_VIDEO_RECALL_ENABLED);
  }

  public isExtendedVideoRecallLinkEnabled(): boolean {
    return this.statsigService.evaluateGate(EP_FEATURE_FLAGS.ETT_EXTENDED_VIDEO_RECALL_LINK_ENABLED);
  }

  public isReportsDirectLinkBugFixed(): boolean {
    return this.statsigService.evaluateGate(EP_FEATURE_FLAGS.EP_REPORTS_DIRECT_LINK_BUG_FIXED);
  }

  public isVehicleGatewayTroubleshootingPhase1Enabled(): boolean {
    return this.statsigService.evaluateGate(EP_FEATURE_FLAGS.VEHICLE_GATEWAY_TROUBLESHOOTING_PHASE_1);
  }

  public getMinimumSupportedVersionForReaderSettings(): number {
    return this.statsigService.evaluateDynamicConfig(
      EP_FEATURE_FLAGS.DVE_DRIVER_READER_SETTINGS_COMPATIBLE_SW_VERSION,
    )?.value?.minimum_supported as number;
  }

  public getMinimumSupportedVersionForEightHoursSettings(): number {
    return this.statsigService.evaluateDynamicConfig(
      EP_FEATURE_FLAGS.DVE_DRIVER_READER_SETTINGS_COMPATIBLE_SW_VERSION,
    )?.value?.eight_hours_supported as number;
  }

  public isAlertsViaWhatsAppEnabled(): boolean {
    return this.statsigService.evaluateGate(EP_FEATURE_FLAGS.EP_ALERTS_VIA_WHATSAPP_ENABLED);
  }

  public isIMEIInfoEnabled(): boolean {
    return this.statsigService
      .evaluateGate(EP_FEATURE_FLAGS.ETT_IS_HARDWARE_IMEI_INFO_ENABLED);
  }

  public isBroadcastMessageEnhancementEnabled(): boolean {
    return this.statsigService.evaluateGate(EP_FEATURE_FLAGS.EP_BROADCAST_MESSAGE_ENHANCEMENT_ENABLED);
  }

  public isAlertsViaSmsEnabled(): boolean {
    return this.statsigService.evaluateGate(EP_FEATURE_FLAGS.EP_ALERTS_VIA_SMS_ENABLED);
  }

  public isDocumentTemplateVisibilityEnabled(): boolean {
    return this.statsigService.evaluateGate(EP_FEATURE_FLAGS.EP_DOCUMENT_TEMPLATE_VISIBILITY_ENABLED);
  }

  public isReportsAlternateWidthCalculationEnabled(): boolean {
    return this.statsigService.evaluateGate(EP_FEATURE_FLAGS.REPORTS_ALTERNATE_WIDTH_CALCULATION_ENABLED);
  }
}
